export const CONSUME_ITEM = 'CONSUME_ITEM';
export const CONSUME_ITEM_SUCCESS = 'CONSUME_ITEM_SUCCESS';
export const CONSUME_ITEM_FAILURE = 'CONSUME_ITEM_FAILURE';
export const RESET_CONSUMABLE_ITEM = 'RESET_CONSUMABLE_ITEM';
